import React, { useCallback, useState } from "react";
import { RefreshCw } from "lucide-react";
import { FieldHint } from "./CreateEventFormUi";
import {
  COVER_GRADIENTS,
  pickCoverGradientOptions,
  coverBackgroundStyle,
} from "../../lib/coverGradients";

export default function CoverColorPicker({ value, onChange, hint }) {
  const [options, setOptions] = useState(() =>
    pickCoverGradientOptions({ count: 4, includeId: value }),
  );

  const shuffle = useCallback(() => {
    setOptions(pickCoverGradientOptions({ count: 4, includeId: value }));
  }, [value]);

  return (
    <div className="space-y-3">
      <FieldHint>
        {hint ||
          "Pick a colour to tell your events apart at a glance — handy when you run several regular nights."}
      </FieldHint>
      <div className="flex items-center gap-3 flex-wrap">
        {options.map((id) => {
          const selected = value === id;
          return (
            <button
              key={id}
              type="button"
              onClick={() => onChange(id)}
              className={`rounded-md2 w-14 h-14 border border-black/[0.08] transition-shadow duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-plum/25 focus-visible:ring-offset-1 ${
                selected ? "ring-2 ring-ink/30 ring-offset-1" : ""
              }`}
              style={coverBackgroundStyle(id)}
              data-testid={`cover-${id}-btn`}
              aria-label={COVER_GRADIENTS[id].label}
              aria-pressed={selected}
            />
          );
        })}
        <button
          type="button"
          onClick={shuffle}
          className="rounded-md2 w-14 h-14 border border-black/[0.08] bg-white inline-flex items-center justify-center text-ink/55 hover:text-ink hover:bg-cream/60 transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-plum/25 focus-visible:ring-offset-1"
          aria-label="Show different colour options"
          data-testid="cover-shuffle-btn"
        >
          <RefreshCw className="w-5 h-5" strokeWidth={2} aria-hidden />
        </button>
      </div>
    </div>
  );
}
